<template>
    <div class="container">
        <div class="wrap">
            <progress-bar :list="list" :step="step" :step_="step_"></progress-bar>
            <div class="content">
                <div class="content-box">
                    <transition name="product-info" appear>
                        <div class="product-info">
                            <div class="info-head">
                                相似度: <span class="icon" :class="{active:currentProduct.similarity>=item}"
                                           v-for="(item,index) in 5" :key="index"></span>
                            </div>
                            <div class="info-image">
                                <img :src="currentProduct.image" alt="">
                            </div>
                            <div class="info-txt">
                                <div class="info-txt-title">
                                    <h3>{{currentProduct.title}}</h3>
                                </div>
                                <div class="line"></div>
                                <div class="info-txt-attribute">
                                    <span>
                                        价格 : {{currentProduct.price}}
                                    </span>
                                    <span>
                                        库存 : {{currentProduct.inventory}}
                                    </span>
                                    <span>
                                        信誉 : {{ currentProduct.creditworthiness }}
                                    </span>
                                    <span>
                                        平台 : {{currentProduct.platform}}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </transition>
                    <transition name="product-publish" appear>
                        <div class="product-publish">
                            <div class="publish-menu">

                            </div>
                            <div class="publish-content">
                                <div :class="{_finish_:$store.state.selectData.finish}"
                                     class="price-wrap">
                                    <div class="item">
                                        <label>
                                            Price
                                            <i class="iconfont icon-wenhao"  @click="showInfoModal('Price')"></i>
                                        </label>
                                        <input type="number" autocomplete="off" name="price"
                                               v-model="product.price">
                                    </div>
                                    <div class="item">
                                        <label>
                                            MSRP
                                            <i class="iconfont icon-wenhao"  @click="showInfoModal('MSRP')"></i>
                                        </label>
                                        <input type="number" autocomplete="off" name="msrp"
                                               v-model="product.msrp">
                                    </div>
                                    <div class="item ">
                                        <label>
                                            Logistic
                                            <i class="iconfont icon-wenhao"  @click="showInfoModal('Logistic')"></i>
                                        </label>
                                        <input type="number" autocomplete="off" name="logistic"
                                               v-model="product.logistic">
                                    </div>
                                    <div class="item">
                                        <label>
                                            Inventory
                                            <i class="iconfont icon-wenhao" @click="showInfoModal('Inventory')"></i>
                                        </label>
                                        <input type="number" autocomplete="off" name="inventory"
                                               v-model="product.inventory">
                                    </div>
                                    <div class="item">
                                        <label>
                                            TimeLiness
                                            <i class="iconfont icon-wenhao"  @click="showInfoModal('TimeLiness')"></i>
                                        </label>
                                        <input type="number" autocomplete="off" name="timeliness"
                                               v-model="product.timeliness">
                                    </div>
                                    <div class="item">
                                        <label>
                                            UPC
                                            <i class="iconfont icon-wenhao"  @click="showInfoModal('UPC')"></i>
                                        </label>
                                        <input type="number" autocomplete="off" name="upc"
                                               v-model="product.upc">
                                    </div>
                                    <div class="item">
                                        <label>
                                            Profits
                                            <i class="iconfont icon-wenhao"  @click="showInfoModal('Profits')"></i>
                                        </label>
                                        <input type="text" autocomplete="off" name="upc" readonly
                                               style="cursor: not-allowed"
                                               v-model="product.profits">
                                    </div>
                                </div>
                            </div>
                            <div class="publish-foot">
                                <div class="next">
                                    <div class="next-btn" @click="$router.push('/experiment_3_0')">
                                        上一步
                                    </div>
                                </div>
                                <div class="next">
                                    <div class="next-btn" @click="$router.push('/experiment_5_0')">
                                        下一步
                                    </div>
                                </div>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>
        </div>
        <div tabindex="0" ref="modalwrap" class="modal-wrap" :class="{active:showInfo}" @keyup.esc="showInfo=false">
            <div class="modal">
                <img class="img_1" src="./../assets/images/border_bg.png" alt="">
                <img class="img_2" src="./../assets/images/border_bg.png" alt="">
                <img class="img_3" src="./../assets/images/border_bg.png" alt="">
                <img class="img_4" src="./../assets/images/border_bg.png" alt="">
                <div class="head">
                    {{modalData.name}}
                    <div class="iconclose" @click="showInfo=false"></div>
                </div>
                <div class="content">
                    <div class="section" v-for="(item,index) in modalData.content" :key="index">
                        <div class="tit">
                            {{item.title}}
                        </div>
                        <div class="details" v-if="item.content.length>0">
                            <p v-for="(itemm,indexx) in item.content" :key="`${index}_${indexx}`">
                                {{itemm}}
                            </p>
                        </div>
                    </div>
                    <div class="example" v-if="modalData.example && modalData.example.length>0">
                        <h1>优秀的案例</h1>
                        <p v-for="(item,index) in modalData.example" :key="`e_${index}`">
                            {{item}}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import store from './../store'
    import AlertMessage from '../components/AlertMessage/index'
    import ProgressBar from "../components/common/ProgressBar"
    import SelectionMenu from "../components/common/SelectionMenu"

    export default {
        components: {
            ProgressBar, SelectionMenu
        },
        name: "experiment_2_0",
        data() {
            return {
                modalData:{},
                showInfo: false,
                tag: '',
                keyword: '',
                pictureList: [],
                left: 0,
                activeRight: 1,
                urlInputWrap: false,
                urlInput: '',
                product: {
                    id: '',
                    title: '',
                    tags: [],
                    keywords: [],
                    sku: '',
                    brand: '',
                    description: '',
                    image: '',
                    attachments: [],
                    price: '',
                    msrp: '',
                    logistic: '',
                    inventory: '',
                    timeliness: '',
                    upc: '',
                    declareName: '',
                    declareLocalName: '',
                    packageLength: '',
                    packageWidth: '',
                    packageHeight: '',
                    customHsCode: '',
                    weight: '',
                    packageWeight: '',
                    countryOfOrigin: '',
                    customDeclareValue: '',
                    hasPowder: false,
                    hasLiquid: false,
                    hasBattery: false,
                    hasReturn: false,
                    hasRefund: false
                },
            }
        },
        computed: {
            step: function () {
                let $arr = /experiment_([0-9]+)_([0-9]+)/.exec(this.$route.path);
                return $arr[1]
            },
            step_: function () {
                let $arr = /experiment_([0-9]+)_([0-9]+)/.exec(this.$route.path);
                return $arr[2];
            },
            selectData: function () {
                return this.$store.state.selectData.dataContrast.selectItem
            },
            currentExperimentId: function () {
                return this.$store.state.currentExperiment.id
            },
            selectProductId: function () {
                return this.$store.state.selectData.selectProductId
            },
            currentProduct: function () {
                let arr = this.$store.state.selectData.dataContrast[this.$store.state.selectData.selectProductId];
                for (let i = 0; i < arr.length; i++) {
                    if (arr[i].id === this.$store.state.selectData.dataContrastId) {
                        return arr[i]
                    }
                }
            },
            list: function () {
                return this.$store.state.currentExperiment
            }
        },
        created() {
            this.$axios.post('/student/editor/product/current_editor_product', {id: this.currentExperimentId}).then(res => {
                if (res.login && res.succeed) {
                    for (let i in this.product) {
                        this.product[i] = this.$store.state.selectData.product[i]
                    }
                } else if (res.login && !res.succeed) {
                    this.$axios.post('/student/editor/product/create', {
                        'experiment.id': this.currentExperimentId,
                        'selectProduct.id': this.selectProductId
                    }).then(res => {
                        if (res.login && res.succeed) {
                            this.product.id = res.product.id
                        }
                    })
                }
            })
        },
        beforeRouteEnter(to, from, next) {
            if (store.state.selectData.selectProductId === '') {
                AlertMessage({type: 'error', message: '请在[大数据匹配]-[货源匹配]页面,选中一款产品', time: 6000});
                return false
            }
            if (store.state.selectData.dataContrastId === '') {
                AlertMessage({type: 'error', message: '请在[大数据匹配]-[数据对比]页面,添加数据并且选中一款产品进行刊登', time: 6000});
                return false
            }
            next()
        },
        watch: {
            'product': {
                handler: function (newV, oldV) {
                    if (this.product.price && this.product.logistic) {
                        this.product.profits = ((parseFloat(this.product.price) + parseFloat(this.product.logistic)) * 0.85).toFixed(2);
                    }
                    this.$store.dispatch('submitRecode', {label: 'product', value: newV})
                },
                deep: true
            }
        },
        methods: {
            showInfoModal(v){
                this.showInfo = true;
                this.modalData = this.$store.state.productInfo[v]
                this.$nextTick(()=>{
                    this.$refs['modalwrap'].focus()
                })
            },
            beforeEnter: function (el) {

            },
            enter: function (el, done) {
                Velocity(el, {opacity: 0, scale: 0}, {duration: 0})
                Velocity(el, {opacity: 1, scale: 1}, {duration: 300})
                Velocity(el, {opacity: 1, scale: 0.5}, {duration: 300})
                Velocity(el, {opacity: 1, scale: 1}, {duration: 600})
                Velocity(el, {complete: done})
            },
            leave: function (el, done) {
                Velocity(el, {opacity: 1, scale: 0}, {duration: 300})
            },
            MultiInput(label, key) {
                if (this[key].replace(/\s?/, '') === '') {
                    return false;
                }
                this.product[label].push(this[key]);
                this[key] = ""
                this.$refs[key].focus()
            },
        }
    }
</script>

<style scoped lang="scss">
    $rem: 0.01rem;
    .product-info-enter-active {
        transition: all .6s ease;
    }

    .product-info-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .product-info-enter, .product-info-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */
    {
        transform: translateX(-30px);
        opacity: 0;
    }

    .product-publish-enter-active {
        transition: all .6s ease;
    }

    .product-publish-leave-active {
        transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .product-publish-enter, .product-publish-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */
    {
        transform: translateX(30px);
        opacity: 0;
    }

    div.container {
        width: 100%;

        box-sizing: border-box;
        padding-top:10px;
        display: flex;
        justify-content: center;

        div.wrap {
        padding-top: 10*$rem;
            width: 1622*$rem;
            color: #ffffff;

            div.title > h1 {
                font-size: 44*$rem;
                font-weight: bolder;
            }

            div.content {
                width: 1622*$rem;
                height: 775*$rem;
                box-sizing: border-box;
                background: url("./../assets/images/experiment_bg.png");
                background-size: cover;
                display: flex;
                justify-content: center;
                padding-top: 44*$rem;

                .content-box {
                    display: flex;
                    align-items: flex-start;

                    div.product-info {
                        width: 356*$rem;
                        height: 632*$rem;
                        background: #344D76;
                        border: 2*$rem solid #25FCFF;
                        margin-right: 12*$rem;
                        padding: 16*$rem;
                        box-sizing: border-box;

                        div.info-head {
                            width: 100%;
                            height: 44*$rem;
                            background: url("./../assets/images/xiangsidu.png") 0 0 no-repeat;
                            background-size: 100% 100%;
                            margin-bottom: 12*$rem;
                            font-size: 16*$rem;
                            font-weight: bold;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            color: #25FCFF;

                            span.icon {
                                width: 28*$rem;
                                height: 8*$rem;
                                border-radius: 10*$rem;
                                background: #344d76;
                                margin-right: 4*$rem;

                                &.active {
                                    background: #FF8700;
                                }

                                &:first-child {
                                    margin-left: 20*$rem;
                                }
                            }
                        }

                        div.info-image {
                            box-sizing: border-box;
                            border: 2*$rem solid #25FCFF;
                            height: 324*$rem;
                            margin-bottom: 16*$rem;
                            display: flex;
                            justify-content: center;
                            align-items: center;

                            > img {
                                max-width: 100%;
                                max-height: 100%;

                            }
                        }

                        div.info-txt {
                            height: 204*$rem;
                            background: #012154;
                            padding: 14*$rem;
                            box-sizing: border-box;
                            border: 2*$rem solid #25FCFF;
                            color: #25FCFF;
                            font-size: 16*$rem;

                            > div.info-txt-title {
                                padding-bottom: 14*$rem;
                                font-weight: bold;
                            }

                            > div.line {
                                border-top: 2*$rem dashed #25FCFF;
                            }

                            > div.info-txt-attribute {
                                padding: 14*$rem 0;
                                display: flex;
                                flex-wrap: wrap;

                                > span {
                                    width: 50%;
                                    margin-bottom: 6*$rem;
                                }
                            }
                        }
                    }

                    div.product-publish {
                        border: 2*$rem solid #25FCFF;
                        position: relative;
                        width: 1128*$rem;
                        height: 632*$rem;
                        background: #344D76;
                        padding: 16*$rem;
                        padding-bottom: 66*$rem;
                        box-sizing: border-box;

                        > div.publish-menu {
                            display: flex;
                            margin-bottom: 32*$rem;

                            > div.menu-item {
                                cursor: pointer;
                                width: 164*$rem;
                                height: 44*$rem;
                                line-height: 44*$rem;
                                text-align: center;
                                background-image: url("./../assets/images/next_button_bg.png");
                                background-size: 100%;
                                font-size: 16*$rem;
                                margin-right: 16*$rem;
                                transition: box-shadow 0.6s ease-in-out;

                                &:hover {
                                    transition: box-shadow 0.6s ease-in-out;
                                    box-shadow: 0 0 30*$rem #25FCFF inset;
                                }

                                &.active {
                                    background-image: url("./../assets/images/back_home_bg.png");

                                    &:hover {
                                        transition: box-shadow 0.6s ease-in-out;
                                        box-shadow: 0 0 30*$rem #FF8700 inset;
                                    }
                                }
                            }
                        }

                        > div.publish-content {
                            > div {
                                display: flex;
                                flex-wrap: wrap;
                                box-sizing: border-box;
                                padding-right: 60*$rem;

                                &.logistics-wrap {
                                    > div.item > label {
                                        width: 250*$rem;
                                    }

                                    > div.item > input, textarea {
                                        width: calc(100% - 2.5rem);
                                    }
                                }

                                > div.item {
                                    height: 44*$rem;
                                    display: flex;
                                    align-items: center;
                                    margin-bottom: 20*$rem;
                                    width: 50%;
                                    animation-fill-mode: both;
                                    animation-name: Aopacity;
                                    animation-timing-function: ease-in-out;
                                    animation-duration: 0.6s;

                                    &.noheight {
                                        height: auto;
                                    }

                                    &.uniline {
                                        width: 100%;
                                    }

                                    div.check {
                                        display: flex;
                                        color: #25FCFF;
                                        margin-right: 48*$rem;
                                        cursor: pointer;
                                        align-items: center;

                                        &:hover span.icon {
                                            border-color: #FF8700;
                                        }

                                        span.icon {
                                            box-sizing: border-box;
                                            width: 20*$rem;
                                            height: 20*$rem;
                                            border: 2*$rem solid #25FCFF;
                                            background: #012154;
                                            margin-right: 6*$rem;
                                            position: relative;
                                        }

                                        span.txt {

                                        }

                                        &.active span.icon:before {
                                            content: '';
                                            position: absolute;
                                            width: 8*$rem;
                                            height: 8*$rem;
                                            background: #FF8700;
                                            top: 0;
                                            left: 0;
                                            right: 0;
                                            bottom: 0;
                                            margin: auto;
                                        }
                                    }

                                    > label {
                                        width: 200*$rem;
                                        height: 100%;
                                        display: flex;
                                        justify-content: flex-end;
                                        align-items: center;
                                        font-size: 16*$rem;
                                        color: #25FCFF;
                                        letter-spacing: 0.3*$rem;

                                        i.iconfont {
                                            padding: 0 10*$rem;
                                            color: #ffffff;
                                            cursor: pointer;
                                            &:hover {
                                                color: #F44336;
                                            }
                                        }
                                    }

                                    > div.select-input {
                                        width: calc(100% - 2rem);
                                        min-height: 44*$rem;
                                        border: 2*$rem solid #25FCFF;
                                        background: #012154;
                                        box-sizing: border-box;
                                        outline: none;
                                        padding: 0 10*$rem;
                                        color: #ffffff;
                                        display: flex;
                                        flex-wrap: wrap;
                                        align-items: center;
                                        max-height: 76*$rem;
                                        overflow: auto;

                                        .tag-select-input-wrap {
                                            display: flex;
                                            align-items: center;
                                            flex-wrap: wrap;
                                            width: 100%;

                                            div.list-item {
                                                display: flex;
                                                align-items: center;
                                                font-size: 14*$rem;
                                                margin: 4*$rem 0;
                                                height: 26*$rem;
                                                padding: 0 6*$rem;
                                                border-radius: 4*$rem;
                                                border: 1*$rem solid #607D8B;
                                                margin-right: 6*$rem;
                                                background: #28436d;

                                                > i {
                                                    cursor: pointer;
                                                    padding: 0 4*$rem;
                                                    font-size: 12*$rem;

                                                    &:hover {
                                                        color: #F44336;
                                                    }
                                                }
                                            }

                                            > div.input {
                                                flex-grow: 1;

                                                > input {
                                                    width: 100%;
                                                    height: 26*$rem;
                                                    font-size: 14*$rem;
                                                    background: #012154;
                                                    border: none;
                                                    box-sizing: border-box;
                                                    outline: none;
                                                    color: #ffffff;
                                                }
                                            }
                                        }

                                    }

                                    > input, > textarea {
                                        max-width: calc(100% - 2rem);
                                        width: calc(100% - 2rem);
                                        height: 100%;
                                        border: 2*$rem solid #25FCFF;
                                        background: #012154;
                                        box-sizing: border-box;
                                        outline: none;
                                        padding: 0 10*$rem;
                                        color: #ffffff;
                                    }

                                    textarea {
                                        padding: 10*$rem;
                                        font-size: 16*$rem;
                                        font-family: "Microsoft Yahei", serif;
                                    }
                                }

                                > div.line {
                                    width: 100%;
                                    margin-left: 200*$rem;
                                    margin-top: 10*$rem;
                                    margin-bottom: 10*$rem;
                                    border-top: 1*$rem dashed #25FCFF;
                                    animation-fill-mode: both;
                                    animation-name: Aopacity;
                                    animation-timing-function: ease-in-out;
                                    animation-duration: 0.6s;
                                }

                                &.publish-content-picture {
                                    padding-right: 0;

                                    div.picture-wrap {
                                        width: 100%;
                                        display: flex;
                                        flex-direction: column;

                                        div.picture-wrap-1 {
                                            display: flex;

                                            div.upload-box {
                                                width: 332*$rem;
                                                height: 176*$rem;
                                                background: #012154;
                                                display: flex;
                                                flex-direction: column;
                                                justify-content: center;
                                                align-items: center;
                                                position: relative;

                                                span {
                                                    &.btn {
                                                        width: 276*$rem;
                                                        height: 36*$rem;
                                                        cursor: pointer;
                                                        display: flex;
                                                        align-items: center;
                                                        box-sizing: border-box;
                                                        justify-content: center;
                                                        background-image: url("./../assets/images/chang_btn_bg.png");
                                                        background-size: 100% 100%;
                                                        transition: all 0.6s ease-in-out;
                                                        position: relative;

                                                        > i {
                                                            margin-right: 6*$rem;
                                                        }

                                                        > span {
                                                            font-size: 14*$rem;
                                                        }

                                                        &:hover {
                                                            box-shadow: 0 0 10*$rem #ffffff inset;
                                                            transition: all 0.6s ease-in-out;
                                                        }
                                                    }

                                                    &.line {
                                                        color: #25FCFF;
                                                        padding: 10*$rem;
                                                    }
                                                }

                                                div.url-input-wrap {
                                                    position: absolute;
                                                    bottom: -16*$rem;
                                                    left: 0;
                                                    transform: translate(0, 100%);
                                                    width: 400*$rem;
                                                    height: 40*$rem;
                                                    background: #a0a0a0;
                                                    border-radius: 2*$rem;
                                                    box-sizing: border-box;
                                                    display: flex;
                                                    align-items: center;
                                                    box-shadow: 0px 10px 10px -6px #012154;
                                                    z-index: -1;
                                                    opacity: 0;
                                                    padding: 0 6*$rem;
                                                    transition: all 0.6s linear;

                                                    &.active {
                                                        transition: all 0.6s linear;
                                                        z-index: 1;
                                                        opacity: 1;
                                                    }

                                                    &:before {
                                                        content: '';
                                                        position: absolute;
                                                        top: 1*$rem;
                                                        left: 10*$rem;
                                                        transform: translate(0, -100%);
                                                        border-left: 10*$rem solid transparent;
                                                        border-right: 10*$rem solid transparent;
                                                        border-top: 10*$rem solid transparent;
                                                        border-bottom: 10*$rem solid #a0a0a0;
                                                    }

                                                    > input {
                                                        padding: 0;
                                                        width: 100%;
                                                        height: 100%;
                                                        height: 30*$rem;
                                                        border: none;
                                                        outline: none;
                                                        padding: 8*$rem 10*$rem;
                                                        box-sizing: border-box;
                                                    }

                                                    > span {
                                                        width: 60*$rem;
                                                        text-align: center;
                                                        font-size: 14*$rem;
                                                        cursor: pointer;

                                                        &:hover {
                                                            color: #F44336;
                                                        }
                                                    }
                                                }
                                            }

                                            div.upload-drag {
                                                width: 176*$rem;
                                                height: 176*$rem;
                                                border: 1*$rem dashed #4ED9FF;
                                                box-sizing: border-box;
                                                text-align: center;
                                                line-height: 176*$rem;
                                                color: #ffffff;
                                                letter-spacing: 1*$rem;
                                                cursor: pointer;

                                                &.ing, &:hover {
                                                    border-color: #F44336;
                                                    background: #FF8700;
                                                }
                                            }

                                            div.upload-description {
                                                padding-left: 30*$rem;
                                                flex-grow: 1;
                                                width: 494*$rem;
                                                height: 176*$rem;
                                                font-size: 14*$rem;
                                                color: #25FCFF;
                                                display: flex;
                                                flex-direction: column;
                                                justify-content: space-between;

                                            }
                                        }

                                        div.line {
                                            width: 100%;
                                            height: 1*$rem;
                                            border-top: 1*$rem dashed #4ED9FF;
                                            margin: 50*$rem 0;
                                        }

                                        div.picture-wrap-2 {
                                            display: flex;
                                            justify-content: space-between;

                                            div.main {
                                                width: 160*$rem;
                                                height: 160*$rem;
                                                margin-right: 16*$rem;
                                                background-image: url("./../assets/images/pic-main.png");
                                                background-size: 100% 100%;
                                                position: relative;

                                                &:hover {
                                                    div.del-icon-my {
                                                        visibility: initial;
                                                    }
                                                }

                                                > img {
                                                    width: 100%;
                                                    height: 100%;
                                                }
                                            }

                                            div.attached {
                                                display: flex;
                                                width: calc(100% - 1.6rem);
                                                height: 160*$rem;
                                                position: relative;
                                                overflow: hidden;

                                                div.attached-wrap {
                                                    display: flex;
                                                    position: absolute;
                                                    left: 0;
                                                    top: 0;
                                                    transition: all 0.3s ease-in-out;

                                                    div.img-box {
                                                        width: 160*$rem;
                                                        height: 160*$rem;
                                                        margin: 0 16*$rem 0 0;
                                                        background-image: url("./../assets/images/pic-attached.png");
                                                        background-size: 100% 100%;
                                                        position: relative;

                                                        > img {
                                                            width: 100%;
                                                            height: 100%;
                                                        }

                                                        > div.num {
                                                            position: absolute;
                                                            width: 22*$rem;
                                                            height: 22*$rem;
                                                            display: flex;
                                                            justify-content: center;
                                                            align-items: center;
                                                            left: 3*$rem;
                                                            top: 3*$rem;
                                                            background: #FF8700;
                                                            border-radius: 50%;
                                                            box-shadow: 2px 2px 6px 0px #344d76;
                                                            visibility: hidden;

                                                            &.active {
                                                                visibility: initial;
                                                            }
                                                        }

                                                        &:hover > div.del-icon-my.active {
                                                            visibility: visible;
                                                        }

                                                    }
                                                }

                                                div.next, div.prev {
                                                    position: absolute;
                                                    top: 0;
                                                    bottom: 0;
                                                    margin: auto;
                                                    height: 100%;
                                                    width: 30*$rem;
                                                    background: #012154;
                                                    cursor: pointer;
                                                    display: flex;
                                                    align-items: center;
                                                    justify-content: center;

                                                    > i {
                                                        font-size: 20*$rem;
                                                    }

                                                    &.active {
                                                        visibility: hidden;
                                                    }

                                                    &:hover i {
                                                        color: #FF8700;
                                                    }
                                                }

                                                div.next {
                                                    right: 0;
                                                }

                                                div.prev {
                                                    left: 0;
                                                }
                                            }
                                        }
                                    }
                                }
                            }


                        }

                        > div.publish-foot {
                            position: absolute;
                            bottom: 0;
                            left: 0;
                            width: 100%;
                            display: flex;
                            align-items: center;
                            justify-content: flex-end;
                            padding-right: 76*$rem;
                            padding-bottom: 16*$rem;
                            box-sizing: border-box;

                            div.next {
                                > div.next-btn {
                                    cursor: pointer;
                                    font-size: 16*$rem;
                                    text-align: center;
                                    line-height: 44*$rem;
                                    width: 164*$rem;
                                    height: 44*$rem;
                                    margin-left: 20*$rem;
                                    background: url("./../assets/images/next_button_bg.png");
                                    background-size: cover;
                                    font-family: "Microsoft Yahei", serif;
                                    font-weight: bold;
                                    transition: all 0.6s ease-in-out;

                                    &:hover {
                                        box-shadow: 0 0 30*$rem #4ED9FF inset;
                                        transition: all 0.6s ease-in-out;
                                    }

                                    &.submit {
                                        background-image: url("./../assets/images/back_home_bg.png");
                                        background-size: 100% 100%;

                                        &:hover {
                                            box-shadow: 0 0 30*$rem #FF8700 inset;
                                            transition: all 0.6s ease-in-out;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        div.modal-wrap {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.5);
            z-index: -1;
            display: flex;
            justify-content: center;
            opacity: 0;
            transition: opacity 0.3s linear;
            overflow-y: auto;
            &:focus {
                outline: none;
            }

            &.active {
                opacity: 1;
                transition: opacity 0.3s linear;
                z-index: 11;
            }

            div.modal {
                position: absolute;
                top: 20*$rem;
                margin-bottom: 20*$rem;
                width: 1128px;
                padding: 20*$rem;
                background: url("./../assets/images/info_modal_bg.png") 0 0 no-repeat;
                background-size: cover;
                color: #25FDFF;

                > .img_1 {
                    position: absolute;
                    top: -4*$rem;
                    left: -4*$rem;
                    transform: rotate(90deg);
                }

                > .img_2 {
                    position: absolute;
                    top: -4*$rem;
                    right: -4*$rem;
                    transform: rotate(180deg);
                }

                > .img_3 {
                    position: absolute;
                    bottom: -4*$rem;
                    left: -4*$rem;
                    transform: rotate(0deg);
                }

                > .img_4 {
                    position: absolute;
                    bottom: -4*$rem;
                    right: -4*$rem;
                    transform: rotate(-90deg);
                }

                > .head {
                    display: flex;
                    align-items: center;
                    background: url("./../assets/images/info_modal_head_bg.png") 0 0 no-repeat;
                    background-size: 100% 100%;
                    font-size: 18*$rem;
                    height: 44*$rem;
                    padding-left: 20*$rem;
                    font-weight: bolder;
                    margin-right: 64*$rem;
                    box-sizing: border-box;
                    position: relative;

                    div.iconclose {
                        width: 44*$rem;
                        height: 44*$rem;
                        background: #FF8700;
                        position: absolute;
                        top: 0;
                        bottom: 0;
                        margin: auto;
                        right: -20*$rem;
                        cursor: pointer;
                        transform: translateX(100%);

                        &:hover {
                            &:before, &:after {
                                border-color: #25FCFF;
                            }
                        }

                        &:before, &:after {
                            content: '';
                            position: absolute;
                            width: 50%;
                            height: 0;
                            top: 0;
                            left: 0;
                            bottom: 0;
                            right: 0;
                            margin: auto;
                            border-top: 2px solid #000;
                            transform: rotate(45deg);
                        }

                        &:after {
                            transform: rotate(135deg);
                        }
                    }
                }

                > .content {
                    padding: 30*$rem 70*$rem;
                    box-sizing: border-box;
                    line-height: 30*$rem;

                    > .section {
                        > .tit {
                            color: #F8870B;
                            font-size: 16*$rem;
                        }

                        > .details {
                            box-sizing: border-box;
                            padding: 6*$rem 20*$rem;
                            font-size: 14*$rem;
                            color: #4ED9FF;
                        }
                    }

                    > .example {
                        background: #334D75;
                        padding: 30*$rem 50*$rem;
                        box-sizing: border-box;

                        > h1 {
                            font-size: 20*$rem;
                            font-weight: bolder;
                            color: #F44336;
                        }
                    }
                }
            }
        }
    }
</style>
